import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import styles from './copilot.module.css';

type CopilotContext = {
  project: { id: string; name: string };
  integrations: { type: string; connected: boolean; syncedAt?: string }[];
  capabilities: { id: string; status: string; available: boolean }[];
};

export function ContextPanel({ projectId }: { projectId: string }) {
  const q = useQuery({
    queryKey: ['copilot-context', projectId],
    queryFn: () => apiFetch<CopilotContext>(`/api/copilot/context?project_id=${projectId}`),
  });

  if (q.isLoading) return <div className={styles.contextPanel}>Context laden…</div>;
  if (q.isError) {
    return <div className={styles.contextPanel}>Context niet beschikbaar.</div>;
  }
  const data = q.data!;
  const liveCount = data.capabilities.filter((c) => c.available).length;

  return (
    <aside className={styles.contextPanel} aria-label="Assistent context">
      <h3 className={styles.contextTitle}>Context</h3>
      <p className={styles.contextMeta}>
        <strong>{data.project.name}</strong>
      </p>
      <section>
        <h4>Integraties</h4>
        {data.integrations.length === 0 ? (
          <p className={styles.contextMuted}>Geen integraties gekoppeld.</p>
        ) : (
          <ul className={styles.contextList}>
            {data.integrations.map((i) => (
              <li key={i.type}>
                {i.type} — {i.connected ? 'actief' : 'niet actief'}
                {i.syncedAt ? (
                  <span className={styles.contextMuted}> · sync {new Date(i.syncedAt).toLocaleDateString('nl-NL')}</span>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </section>
      <section>
        <h4>Capabilities</h4>
        <p className={styles.contextMuted}>
          {liveCount} beschikbaar in dit project (registry + flags).
        </p>
      </section>
    </aside>
  );
}
